import React, { useMemo } from "react";
import WarningIcon from "../Shared/icons/WarningIcon";
import ApproveWithRiskScoreButton from "./ApproveWithRiskScoreButton";
import { ReduxApplication } from "src/types/Application";
import "./PauseIndicatorBanner.scss";
import { useAppSelector } from "src/hooks/redux";
import { getHighRiskApplicants } from "src/utils/Application";

interface PauseIndicatorBannerProps {
  application?: ReduxApplication;
}

const PauseIndicatorBanner: React.FC<PauseIndicatorBannerProps> = ({
  application,
}) => {
  const configuration = useAppSelector(
    (state) => state.applications.configuration
  );
  const highRiskApplicants = useMemo(
    () => getHighRiskApplicants(application, configuration),
    [application, configuration]
  );

  return (
    <div className="pause-indicator-banner">
      <WarningIcon className="pause-icon" />
      <div className="pause-message">
        <strong>
          Application Paused for Manual Review by the Application Screening &
          Support Team.
        </strong>
        <span className="pause-description">
          Please do not take any action until you receive notice that the manual
          review is complete.
        </span>
      </div>
      <div className="pause-actions">
        {application?.applicationId && (
          <ApproveWithRiskScoreButton
            applicationId={application.applicationId}
            highRiskApplicants={highRiskApplicants}
          />
        )}
      </div>
    </div>
  );
};

export default PauseIndicatorBanner;
